var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "55", height: "108", fill: "none", viewBox: "0 0 55 108" }, props),
    React.createElement(
      "g",
      { opacity: ".4" },
      React.createElement(
        "mask",
        { id: "b", width: "55", height: "108", x: "0", y: "0", maskUnits: "userSpaceOnUse" },
        React.createElement("path", { fill: "url(#a)", d: "M0 0h107.74v55H0z", transform: "matrix(0 -1 -1 0 55 107.74)" })
      ),
      React.createElement(
        "g",
        { fill: "#BB6BD9", mask: "url(#b)" },
        React.createElement("path", { d: "M55 106.99c28.93 0 52.38-23.1 52.38-51.61S83.93 3.77 55 3.77c-28.93 0-52.38 23.1-52.38 51.6S26.07 107 55 107z", opacity: ".12" }),
        React.createElement("path", { d: "M55 106.99c21.7 0 39.28-17.33 39.28-38.71 0-21.38-17.59-38.7-39.28-38.7-21.7 0-39.28 17.32-39.28 38.7 0 21.38 17.59 38.7 39.28 38.7z", opacity: ".12" }),
        React.createElement("path", { d: "M55 106.99c14.46 0 26.19-11.56 26.19-25.8 0-14.26-11.73-25.81-26.2-25.81-14.45 0-26.18 11.55-26.18 25.8s11.73 25.8 26.19 25.8z", opacity: ".12" })
      )
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "linearGradient",
        { id: "a", x1: "-37.06", x2: "-3.23", y1: "23.7", y2: "93.07", gradientUnits: "userSpaceOnUse" },
        React.createElement("stop", { stopColor: "#48C993" }),
        React.createElement("stop", { offset: "1", stopColor: "#3AAE97" })
      )
    )
  );
});